<template>
  <ul
    v-if="hasMarketLabels"
    :class="['m-event-early', type]"
    @click.stop.prevent
  >
    <li
      v-for="(item, index) in market.marketLabels"
      :key="index"
      :class="['m-event-early-item', 'early-item'+'-'+marketId+'-'+index]"
      @click="showEarlyInfo(index)"
    >
      <img :src="item.iconUrl">
      <template v-if="isTip">
        <XTooltip
          :selector="`.early-item-${marketId}-${index}`"
          :options="{
            offset: [0, 7],
            placement: 'top'
          }"
        >
          <p>
            {{ item.iconDesc }}
          </p>
          <a
            v-if="item.moreUrl"
            @mousedown.prevent
            @click="jumpTo(item.moreUrl)"
          >
            Read More
          </a>
        </XTooltip>
      </template>
    </li>
  </ul>
</template>

<script>
import { defineComponent, computed, getCurrentInstance } from '@vue/composition-api'
import modalHelper from '@ms/utils/scroll-fixed'
import XTooltip from '@ms/desktop/components/XTooltip.vue'

export default defineComponent({
  name: 'EarlyPayout',
  components: {
    XTooltip
  },
  props: {
    market: {
      type: [Object, undefined],
      default: null
    },
    isTip: {
      type: Boolean,
      default: false
    },
    marketId: {
      type: [String, Number],
      default: '0'
    },
    type: {
      type: String,
      default: 'large' // 'medium' 'small'
    }
  },
  setup(props) {
    const { proxy: vm } = getCurrentInstance()

    const hasMarketLabels = computed(() => {
      return props.market && props.market.marketLabels && props.market.marketLabels.length
    })

    const showEarlyInfo = (index) => {
      if (props.isTip) return false
      const lable = props.market.marketLabels[index]
      let message = `<p>${lable.iconDesc}</p>`
      if (lable.moreUrl) {
        message += `<a href="${lable.moreUrl}">Read More</a>`
      }

      const classNames = ['dialog-early-info']
      vm.$dialog({
        message,
        classNames,
        closeOnClickModal: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'OK',
        cancelButtonText: null
      })
        .then(() => {
          modalHelper.beforeClose()
        })
        .catch(() => {
          modalHelper.beforeClose()
        })
      modalHelper.afterOpen()
    }

    const jumpTo = (url) => {
      window.open(url, '_blank')
    }

    return {
      hasMarketLabels,
      jumpTo,
      showEarlyInfo
    }
  }
})
</script>

<style lang="scss">
.m-event-early {
  display: flex;
  align-items: center;
  margin-right: 10px;

  &-item {
    width: 20px;
    height: 20px;
    margin-left: 8px;
    cursor: default;

    &:first-child {
      margin-left: 0;
    }

    img {
      width: 20px;
      height: 20px;
      vertical-align: unset;
    }

    p {
      color: #333;
      font-size: 12px;
      line-height: 16px;
      white-space: normal;
    }

    a {
      height: 16px;
      // display: inline-block;
      padding-top: 6px;
      color: #267dff;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .x-tooltip {
    padding: 12px 16px;
    background: #f8f8f8;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 31%);
    color: #333;
    line-height: 16px;

    &::after {
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 100%;
      height: 20px;
      content: "";
    }
  }

  &.medium {
    .m-event-early-item {
      width: 18px;
      height: 18px;
      margin-left: 8px;
      cursor: default;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }

  &.small {
    .m-event-early-item {
      width: 16px;
      height: 16px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.dialog-early-info {
  .dialog--body {
    padding-top: 30px;
    margin: 0 20px;
    color: #333;
    font-size: 12px;
    line-height: 18px;

    p {
      color: #333;
      font-size: 14px;
      line-height: 18px;
    }

    a {
      display: block;
      height: 16px;
      margin-top: 8px;
      color: #267dff;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }
  }
}
</style>
